<div (click)="openInvitationDialog()" class="icon-and-title" [class.closed]="!show">
    <span
        hamIconShapes
        class="tell-a-friend"
        icon="assets/hamIcons/tell-a-friend.svg"
        [variant]="'transparent'"
        [size]="'xs'"
        (click)="openInvitationDialog()"
    >
    </span>
    <span class="tell-a-friend" *ngIf="show">{{ 'aumico_reports_referral_invite_text' | i18next }}</span>
</div>
